import { get, post, del, put } from "@utils/axios";

export const getTransactionReq = () => {
  return get(`transaction-management/transactions`);
}